module.exports = "<div class=\"home-page\">\n  Home!\n</div>\n"